<template>
  <div class="text-xs-center">
    <v-dialog v-model="value" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'Loader',
  computed: {
    value() {
      return this.$store.getters.isLoading;
    },
  },
  methods: {
    ...mapMutations(['openLoading', 'closeLoading']),
  },
};
</script>
